import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router/index";
import { MessageBox } from "element-ui";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    collapse: false,
    selfInfo: {},
    menuList: [],
    permissions: [],
    statusList: [],
    typeList: [],
    isLoad: false,
    userStatus: "",
    disabledDate(date) {
      return (
        new Date(
          `${new Date(date).getFullYear()}/${new Date(date).getMonth() +
            1}/${new Date(date).getDate()}`
        ).getTime() >=
        Date.now(
          `${new Date().getFullYear()}/${new Date().getMonth() +
            1}/${new Date().getDate()} 23:59:59`
        )
      );
    },
    bankList: {}
  },
  mutations: {
    setBankList(state, data) {
      state.bankList = data;
    },
    SETLOAD(state, boolean) {
      state.isLoad = boolean;
    },
    navChange(state, method) {
      state.collapse = method;
    },
    SETSELF(state, info) {
      state.selfInfo = info;
      state.userStatus = info.role_name;
      if (router.history.current.name == "login") {
        router.push("/selfData");
      }
    },
    SETMENU(state, menu) {
      state.menuList = menu;
    },
    SETPERMISSIONS(state, permission) {
      state.permissions = permission.permissions;
    },
    SETSTATUS(state, data) {
      state.statusList = data;
    },
    SETTYPE(state, data) {
      state.typeList = data;
    }
  },
  actions: {
    openLoad(context, boolean) {
      context.commit("SETLOAD", boolean);
    },
    getMenu(context) {
      axios.get(`/back/users/menu`).then(res => {
        if (res.data.code == 0) {
          let data = res.data.data;
          Object.keys(data).forEach(key => {
            if (
              Object.keys(data[key].sub).length == 1 &&
              Object.keys(data[key].sub)[0] == "settings.personal"
            ) {
              delete data[key];
              return;
            }
            if (Object.keys(data[key].sub).length == 0) {
              delete data[key];
            }
          });
          context.commit("SETMENU", data);

          if (
            location.pathname.split("/")[1] == "login" ||
            location.pathname.split("/")[1] == "selfData"
          ) {
            return;
          }
          let menu = res.data.data;
          let have = false;
          if (Object.keys(menu).length == 0) {
            router.push("/selfData");
            return;
          }
          Object.keys(menu).forEach(one => {
            Object.keys(menu[one].sub).forEach(name => {
              if (name == location.pathname.split("/")[1]) {
                have = true;
              }
            });
          });
          if (have) {
            return;
          }
          // if (!have) {
          //   router.push("/selfData");
          //   return;
          // }
        }
      });
      axios.get(`/back/users/permissions`).then(res => {
        if (res.data.code == 0) {
          context.commit("SETPERMISSIONS", res.data.data);
        }
      });
      // axios.get(`/back/status`).then(res => {
      //   if (res.data.code == 0) {
      //     context.commit("SETSTATUS", res.data.data);
      //   }
      // });
      // axios.get(`/back/types`).then(res => {
      //   if (res.data.code == 0) {
      //     context.commit("SETTYPE", res.data.data);
      //   }
      // });
    },
    navHandler(context, method) {
      context.commit("navChange", method);
    },
    getSelf(context) {
      axios.get(`/back/users/self`).then(res => {
        if (res.data.code == 0) {
          this.dispatch("getBankList");
          context.commit("SETSELF", res.data.data);
          setTimeout(() => {
            if (window.Echo) {
              // 離開頻道
              window.Echo.leave(`App.User.${res.data.data.id}`);
              // 加入頻道
              window.Echo.private(`App.User.${res.data.data.id}`) // 消息名称
                .notification(notification => {
                  console.log(notification);
                  if (
                    notification.level == 1 ||
                    notification.message.level == 1
                  ) {
                    MessageBox({
                      message: notification.message.content,
                      title: notification.message.title,
                      dangerouslyUseHTMLString: true
                    });
                  }
                  if (
                    notification.type ==
                    "App\\Notifications\\NewPaymentNotification"
                  ) {
                    document.querySelector("#newOrder").play();
                    return;
                  }
                  if (Number(notification.sound)) {
                    document.querySelector("#audiosss").play();
                  }
                });
            }
          }, 1000);
          // this.dispatch("getMenu");
        }
      });
    },
    getBankList(context) {
      axios.get(`/back/bank_code`).then(res => {
        if (res.data.code == 0) {
          context.commit("setBankList", res.data.data);
        }
      });
    }
  },
  modules: {}
});
